import React, { useState, useEffect, useRef } from 'react';
import { useDispatch } from 'react-redux';
import { GroupedVirtuoso } from 'react-virtuoso';
import _ from 'lodash';
import * as lib from '~/dependencies';
import * as actions from '~/store/actions';
import { Container, Header, BoxAlphabetic } from './styles';
import RowList from '../Rows';

const ListContacts = props => {
  const { listContact, tab, scrollToIndex } = props;
  const dispatch = useDispatch();

  const virtuoso = useRef(null);
  // Expose this Ref in order to let the QA Automated tests to scroll on the contact list.
  window.virtuoso = virtuoso;

  const [groupIndices, setGroupIndices] = useState([]);
  const [lastScrollRecondIndex, setLastScrollRecondIndex] = useState(0);

  const allContacts = listContact.reduce(
    (prev, next) => prev.concat(next.data),
    []
  );
  const listGrouped = _(allContacts)
    .groupBy(o => o.letter[0])
    .value();
  const groupCounts = Object.values(listGrouped).map(users => users.length);
  const groups = Object.keys(listGrouped);

  function whenStartReached() {
    const getTabString = number => (number === 0 ? 'Personal' : 'All');
    dispatch(actions.checkNewContacts(getTabString(tab), false, false));
  }

  useEffect(() => {
    /*
     * NWA-1916 - The current app height support up to 7 item per scroll view
     */
    if (
      allContacts?.length &&
      scrollToIndex > 7 &&
      scrollToIndex !== lastScrollRecondIndex &&
      virtuoso?.current
    ) {
      setTimeout(() => {
        const contactScrollTo = allContacts[scrollToIndex];
        const letterScrollToIndex = groups.indexOf(contactScrollTo.letter[0]);
        const estimatedContactScrollIndex =
          scrollToIndex + letterScrollToIndex + 1;
        virtuoso.current.scrollToIndex({
          index: estimatedContactScrollIndex,
          behavior: 'auto',
          align: 'start',
        });

        setLastScrollRecondIndex(scrollToIndex);
      }, 500);
    }
  }, [
    allContacts,
    groups,
    scrollToIndex,
    lastScrollRecondIndex,
    setLastScrollRecondIndex,
    virtuoso,
  ]);

  const listItemsCount = allContacts?.length
    ? allContacts.length + groups?.length - 1
    : 0;

  return (
    <Container listItemsCount={listItemsCount}>
      <GroupedVirtuoso
        ref={virtuoso}
        className="list-container"
        groupIndices={indices => {
          if (groupIndices.length !== indices.length) {
            setGroupIndices(indices);
          }
        }}
        startReached={() => whenStartReached()}
        style={{ width: '100%', height: 630 }}
        groupCounts={groupCounts}
        group={index => <Header>{groups[index]}</Header>}
        item={index => (
          <RowList
            key={index}
            item={allContacts[index]}
            tab={tab}
            contactItemIndex={index}
            {...props}
          />
        )}
      />

      <BoxAlphabetic>
        {groupIndices.map((itemIndex, index) => (
          <span
            role="presentation"
            key={Math.random(index)}
            onClick={e => {
              e.preventDefault();
              virtuoso.current.scrollToIndex(itemIndex + 1);
            }}>
            {groups[index]}
          </span>
        ))}
      </BoxAlphabetic>
    </Container>
  );
};

export default ListContacts;

ListContacts.defaultProps = {
  listContact: [],
  tab: 0,
  scrollToIndex: 0,
};

ListContacts.propTypes = {
  listContact: lib.PropTypes.instanceOf(Object),
  tab: lib.PropTypes.number,
  scrollToIndex: lib.PropTypes.number,
};
